export default {
    getUser: state => state.user,
    getUserLocal: (state) => {
        let user = state.user_local
        let zerado = {
            enviadasMes: 0,
            enviadasDia: 0,
            errosDia: 0,
            recebidasDia: 0
        }

        if('sumaryV2' in user) {
            let sumary = user.sumaryV2

            if(!'enviadasMes' in sumary) sumary['enviadasMes'] = 0
            if(!'enviadasDia' in sumary) sumary['enviadasDia'] = 0
            if(!'errosDia' in sumary) sumary['errosDia'] = 0
            if(!'recebidasDia' in sumary) sumary['recebidasDia'] = 0

            user.sumaryV2 = sumary
            return user
        } else {
            user['sumaryV2'] = zerado
            return user
        }
    },
    getAppID: state => state.app_id,
    getAppVersion: state => {
        return state.versoes.filter(v => v.descricao <= state.versaoAtual )
    },
    getAtualVersion: state => state.versaoAtual,
	getToken: state => state.token,
    getService: state => state.$barramento,
    getApi: state => state.$api,
    getQuerotaxiApi : state => state.$querotaxiApi,
    getRoutes: state => state.routes,
    getMenu: (state, getters, rootState) => {
        //console.log('menu', state.menu)
        let menu = state.menu.filter( item => item.icon.includes(".") )

        let filhas    = state.menu.filter( item => !item.icon.includes("."))
        let subroutes = state.routes

        subroutes     = subroutes.map( f => {
            return (f.meta && f.meta.subroutes) ? {subroutes:f.meta.subroutes, name: f.name} : null
        })
        subroutes     = subroutes.map( s => {
            if(
                s.subroutes.filter( ch => {
                    let fi = filhas.find( f => f.rota == ch )

                    if( fi )
                        return fi.acoes.filter( a => a.status ).length > 0

                }).length > 0
            )
            return {name:s.name, status:true}
            else return {name:s.name, status:false}
        })

        let permitidos = menu.filter( m => subroutes.find(  s => s.name == m.rota && s.status == true ) )
        let resto      = menu.filter( m => !subroutes.find(  s => s.name == m.rota ) )
        let logout     = [{icon: "loggout.png", nome: "Fazer Logout", rota: "login"}]
        return resto.concat(permitidos, logout)
    },
    getChildren: state => {
        return state.menu.filter( item => !item.icon.includes("."))
    },

    getShowInformeLGPD: state => state.showInformeLGPD
}



// WEBPACK FOOTER //
// ./src/store/modules/system/getters.js